import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Theme } from 'src/app/configs/theme.config';
import { CancelBtnType } from 'src/app/core/types/app-cancel-btn.type';

import { AppCloseBgColor } from 'src/app/core/types/app-close-bg-color.type';
import { AppSubmitBgColor } from 'src/app/core/types/app-submit-bg-color.type';

@Component({
  selector: 'app-form-btns',
  templateUrl: './form-btns.component.html',
  styleUrls: ['./form-btns.component.scss'],
  standalone: false,
})
export class FormBtnsComponent {
  cancelBtnType: CancelBtnType = Theme.cancelBtnType;

  @Input('form') input_form: FormGroup;
  @Input('customTitle') input_customTitle: string;
  @Input('loading') input_loading: boolean;
  @Input('isEdit') input_isEdit: any;
  @Input('btnType') input_type: string = 'button';
  @Input() hasMaxWidth: boolean = true;
  @Input('submitBgColor') input_submitBgColor: AppSubmitBgColor = 'primary';
  @Input('closeBgColor') input_closeBgColor: AppCloseBgColor = 'danger';
  @Input('showCloseBtn') input_showCloseBtn: boolean = true;
  @Input('isDisabled') input_isDisabled: boolean = false;

  @Output('onSubmit') output_onSubmit = new EventEmitter<boolean>();
  @Output('onClose') output_onClose = new EventEmitter<boolean>();

  constructor() {}

  onClose() {
    this.output_onClose.emit(true);
  }
  onSubmit() {
    this.output_onSubmit.emit(true);
  }

  getCloseBtnBgColor() {
    let closeBtnBgColorClass: string;

    if (
      this.input_closeBgColor == 'light-dark' ||
      this.cancelBtnType == CancelBtnType.Slate
    )
      closeBtnBgColorClass = 'btn-slate';
    else closeBtnBgColorClass = 'btn-danger';

    return closeBtnBgColorClass;
  }
}
